<template>
  <zen-one :showuserinfo="false" :crumbs="crumbs" title="">
    <z-page title="Paparan Ternakan">
      <!-- <div class="page-container"> -->
        <w-card class="modern-card">
          <div class="card-content">
            <div class="ternakan-container">
              <div class="ternakan-left">
                <div class="image-section">
                  <vueper-slides
                    fade
                    :touchable="false"
                    :arrows-outside="false"
                    :bullets-outside="false"
                    class="slide-box"
                    :slide-ratio="4/3"
                  >
                    <vueper-slide
                      v-for="(slide, i) in slides"
                      :key="i"
                      :image="slide.image"
                    />
                  </vueper-slides>
                  
                  
                  <template v-if="$zutil.anyRole(['1', '2' , '5'])">
                    <div class="upload-section">
                      <input
                        id="file-upload"
                        type="file"
                        accept="image/*"
                        @change="handleFileUpload"
                        multiple
                        class="upload-input-hidden"
                        ref="fileInput"
                      />
                      
                      <label for="file-upload" class="upload-btn">
                        <w-icon class="upload-icon">fal fa-cloud-upload-alt</w-icon>
                        <span>Muat Naik Gambar</span>
                      </label>
                    </div>

                    <div class="attachment-list" v-if="attahecment.length > 0">
                      <h4 class="attachment-title">Gambar Lampiran</h4>
                      <div
                        class="attachment-item"
                        v-for="(dt, ind) in attahecment"
                        :key="ind"
                      >
                        <div class="file-info">
                          <w-icon class="file-icon">fal fa-file-image</w-icon>
                          <a :href="dt.url" class="file-link">{{ dt.name }}</a>
                        </div>
                        <w-button 
                        size="xs" 
                        bg-color="error-light4" 
                        text-color="error" 
                        @click="deletelAttahecment(dt.id)"
                        class="delete-btn"
                      >
                        <w-icon xs>fal fa-trash</w-icon>
                      </w-button>
                      </div>
                    </div>
                  </template>
                </div>
              </div>

              
              <div class="ternakan-right">
                <div class="info-section">
                  <div class="info-header">
                    <h3 class="info-title">Maklumat Ternakan</h3>
                    <div class="livestock-id">
                      <span class="id-label">ID Ternakan:</span>
                      <span class="id-value">{{ data.id_ternakan }}</span>
                    </div>
                  </div>
                  
                  <div class="info-columns">
                    <div class="info-group">
                      <div class="info-item">
                        <div class="info-label">Premis</div>
                        <div class="info-value">{{ data.no_premis }}</div>
                      </div>
                      <div class="info-item">
                        <div class="info-label">Jenis Ternakan</div>
                        <div class="info-value">{{ data.lkp_ternakan }}</div>
                      </div>
                      <div class="info-item">
                        <div class="info-label">No. Pendaftaran</div>
                        <div class="info-value">{{ data.kode }}</div>
                      </div>
                      <div class="info-item">
                        <div class="info-label">Nama Ternakan</div>
                        <div class="info-value">{{ data.nama }}</div>
                      </div>
                      <div class="info-item">
                        <div class="info-label">Baka</div>
                        <div class="info-value">{{ data.lkp_baka }}</div>
                      </div>
                      <div class="info-item">
                        <div class="info-label">Negara Asal</div>
                        <div class="info-value">{{ data.lkp_asal_negara || '-' }}</div>
                      </div>
                      <div class="info-item">
                        <div class="info-label">Jurusan Ternakan</div>
                        <div class="info-value">{{ data.lkp_jurusan }}</div>
                      </div>
                    </div>

                   
                    <div class="info-group">
                      <div class="info-item">
                        <div class="info-label">Nama Bapa</div>
                        <div class="info-value">{{ data.nama_bapa }}</div>
                      </div>
                      <div class="info-item">
                        <div class="info-label">ID Bapa</div>
                        <div class="info-value">{{ data.id_bapa }}</div>
                      </div>
                      <div class="info-item">
                        <div class="info-label">Nama Ibu</div>
                        <div class="info-value">{{ data.nama_ibu }}</div>
                      </div>
                      <div class="info-item">
                        <div class="info-label">ID Ibu</div>
                        <div class="info-value">{{ data.id_ibu }}</div>
                      </div>
                      <div class="info-item">
                        <div class="info-label">Generasi</div>
                        <div class="info-value">{{ data.lkp_gred }}</div>
                      </div>
                      <div class="info-item">
                        <div class="info-label">Kaedah Pembiakan</div>
                        <div class="info-value">{{ data.lkp_kaedah_pembiakan }}</div>
                      </div>
                    </div>

                    
                    <div class="info-group">
                      <div class="info-item">
                        <div class="info-label">Tarikh Lahir</div>
                        <div class="info-value">{{ $zutil.dateformat(data.tarikh_lahir) }}</div>
                      </div>
                      <div class="info-item">
                        <div class="info-label">Jantina</div>
                        <div class="info-value">{{ data.jantina_keterangan }}</div>
                      </div>
                      <div class="info-item">
                        <div class="info-label">Umur</div>
                        <div class="info-value">{{ $zutil.umurbulan(data.tarikh_lahir) }}</div>
                      </div>
                      <div class="info-item">
                        <div class="info-label">Warna</div>
                        <div class="info-value">{{ data.lkp_warna || '-' }}</div>
                      </div>
                      </div>
                      
                      <div class="status-container-bawah" v-if="artStatus.ada_art">
                    <div class="status-wrapper">
                      <span class="status-title">Status ART Terkini:</span>
                      <div class="status-badge" :class="statusClass">
                        <span class="status-dot"></span>
                        {{ artStatus.status_keterangan || '-' }}
                      </div>
                      <span class="status-no-permohonan" v-if="artStatus.no_permohonan && artStatus.no_permohonan !== '-'">
                        ({{ artStatus.no_permohonan }})
                      </span>
                  </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            
            <div class="tabs-section">
              <w-tabs 
                :items="tabs" 
                :no-slider="false" 
                active-class="primary" 
                v-model="activeTab"
                class="modern-tabs"
              >
                <template #item-content.1>
                  <div class="tab-content">
                    <AuditTernakan :data="data" v-if="data.id > 0"/>
                  </div>
                </template>
                
                <template #item-content.2>
                  <div class="tab-content">
                    <AuditArt :data="data" v-if="data.id > 0"/>
                  </div>
                </template>
                <template #item-content.3 v-if="data.jantina == 2">
                 <div class="tab-content">
                   <AuditAnak :data="data" v-if="data.id > 0" />
                 </div>
               </template>
              </w-tabs>
            </div>
          </div>
        </w-card>
      <!-- </div> -->
      <div class="mt2 text-left">
          <button 
              style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              "
              @click="tutup">TUTUP
            </button>&nbsp;
        </div>
    </z-page>
  </zen-one>
</template>

<script>
import ZResource from '@/Modules/z-resource'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css' 
import AuditTernakan from './Show/AuditTernakan.vue';
import AuditArt from './Show/AuditArt.vue';
import AuditAnak from './Show/AuditAnak.vue';

export default {
  extends: ZResource,
  components: { VueperSlides, VueperSlide, AuditTernakan, AuditArt, AuditAnak },
  props: { id: [Array, Object, String] },
  data() {
    return {
      resourceurl: this.api_service + 'ternakan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Daftar Premis & Ternakan', route: '/daftar' },
        { label: 'Ternakan', route: '/daftar/ternakan' },
        { label: 'Papar', route: '/daftar/ternakan/' + this.id },
      ],
      data: { id: 0 },
      attahecment: [],
      slides: [],
      artStatus: {
      ada_art: false,
      lkp_status_id: 0,
      status_keterangan: '-',
      no_permohonan: '-',
      lkp_art: '-',
      tarikh_kemaskini: null,
    },
      tabs: [],
      activeTab: 0,
      files: []
    }
  },
  computed: {
  statusClass() {
    // Mapping status ART → warna badge
    const map = {
      // HIJAU - Berjaya/Aktif/Selesai
      1:  'status-approved',   // Aktif
      3:  'status-approved',   // Sihat
      8:  'status-approved',   // Tersedia
      12: 'status-approved',   // Berjaya
      18: 'status-approved',   // Selesai
      22: 'status-approved',   // Lulus
      29: 'status-approved',   // Diluluskan
      32: 'status-approved',   // Permohonan Diterima
      36: 'status-approved',   // Hidup
      38: 'status-approved',   // Lulus Bersyarat
      42: 'status-approved',   // Pindah Milik

      // BIRU - Dalam Proses
      11: 'status-process',    // Menunggu Pemeriksaan Lanjutan
      17: 'status-process',    // Diperiksa
      25: 'status-process',    // Proses
      26: 'status-process',    // Semakan
      30: 'status-process',    // Menunggu Kelulusan
      31: 'status-process',    // Permohonan Baharu
      34: 'status-process',    // Dalam Tindakan
      35: 'status-process',    // Semakan Perakuan
      39: 'status-process',    // Menunggu PD
      44: 'status-process',    // Permohonan PD

      // KUNING - Draf/Baharu
      16: 'status-draft',      // Baharu
      19: 'status-draft',      // Draf
      27: 'status-draft',      // Semak Semula
      45: 'status-draft',      // Pengisian BSE/FE

      // MERAH - Gagal/Ditolak
      13: 'status-rejected',   // Tidak Berjaya
      21: 'status-rejected',   // Ditolak
      23: 'status-rejected',   // Gagal
      28: 'status-rejected',   // Batal
      33: 'status-rejected',   // Permohonan Ditolak
      37: 'status-rejected',   // Tidak Lulus

      // UNGU - Kehamilan
      4:  'status-pregnant',   // Hamil
      14: 'status-pregnant',   // Melahirkan
      15: 'status-pregnant',   // Gugur

      // KELABU - Tidak Aktif/Mati/Lupus
      2:  'status-none',       // Tidak Aktif
      5:  'status-none',       // Tidak Sihat
      6:  'status-none',       // Disembelih
      7:  'status-none',       // Daftar Mati
      9:  'status-none',       // Habis/Terpakai
      10: 'status-none',       // Luput
      20: 'status-none',       // Tamat
      24: 'status-none',       // Musnah
      40: 'status-none',       // Menunggu Kelahiran
      41: 'status-none',       // Singkir
      43: 'status-none',       // Hilang
      46: 'status-none',       // Lupus
      47: 'status-none',       // Singkir PWL
    }
    return map[this.artStatus.lkp_status_id] || 'status-none'
  },

  statusTextClass() {
    return this.statusClass + '-text'
  },

  statusCardClass() {
    return this.artStatus.ada_art ? '' : 'status-card-empty'
  },
},
  methods: {
    getData() {
        this.$zcomm
          .get(this.api_service + 'ternakan/show/' + this.id, {})
          .then((res) => {
            this.data = res

            // Default tabs (tanpa Anak)
            this.tabs = [
              { title: 'Jejak Audit', content: '' },
              { title: 'Perkhidmatan ART', content: '' },
            ]

            if (this.data.jantina == 2) {
              this.tabs.push({
                title: 'Anak Hasil AI',
                content: '',
              })
            }

            this.getAttahecment()
          })
      },
    tutup() {
      this.$inertia.visit(window.route('daftar.ternakan.index'))
    },
    getAttahecment() {
      this.$zcomm
        .get(this.api_service + 'attahecment/list', {
          model_id: this.data.id,
          model: '\\App\\Models\\Ternakan',
        })
        .then((res) => {
          this.attahecment = res
          this.slides = res.map((a) => ({
            title: a.information,
            image: a.url,
          }))
        })
    },
    handleFileUpload(event) {
      this.files = event.target.files
      if (this.files.length > 0) {
        this.uploadImg('\\App\\Models\\Ternakan')
      }
    },
    uploadImg(item) {
      let formData = new FormData()
      for (let i = 0; i < this.files.length; i++) {
        formData.append('files[' + i + ']', this.files[i])
      }
      formData.append('model', item)
      formData.append('model_id', this.data.id)
      
      this.$zcomm.post('attahecment.upload', formData).then(() => {
        this.getAttahecment()
        this.$refs.fileInput.value = ''
        this.files = []
      })
    },
    getArtStatus() {
    this.$zcomm
      .get(this.api_service + 'art/status/' + this.id, {})
      .then((res) => {
        this.artStatus = res
      })
      .catch(() => {
        this.artStatus = {
          ada_art: false,
          status_keterangan: 'Tiada Permohonan ART',
        }
      })
  },
    deletelAttahecment(id) {
      if (confirm('Are you sure to delete this record?')) {
        this.$zcomm.get(this.$route('attahecment.delete', id), {}).then(() => this.getAttahecment())
      }
    },
  },
  mounted() {
    this.getData()
    this.getArtStatus()
  },
}
</script>

<style scoped>

.status-container-bawah {
  padding: 16px 20px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
}

.status-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.status-title {
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
}

.status-no-permohonan {
  font-size: 13px;
  color: #6c757d;
  font-weight: 500;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  border-radius: 20px; /* Bentuk pill */
  font-size: 13px;
  font-weight: 600;
  margin: 0 !important; /* Elak margin dari parent */
  line-height: 1.2;
}

.status-badge .status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}

/* HIJAU - Berjaya/Aktif/Selesai */
.status-approved { 
  background-color: #d4edda !important; 
  color: #155724 !important; 
  border: 1px solid #c3e6cb; 
}
.status-approved .status-dot { 
  background-color: #28a745; 
  animation: pulse-green 2s infinite; 
}

/* BIRU - Dalam Proses */
.status-process { 
  background-color: #d1ecf1 !important; 
  color: #0c5460 !important; 
  border: 1px solid #bee5eb; 
}
.status-process .status-dot { 
  background-color: #17a2b8; 
  animation: pulse-blue 2s infinite; 
}

/* KUNING - Draf/Baharu */
.status-draft { 
  background-color: #fff3cd !important; 
  color: #856404 !important; 
  border: 1px solid #ffeeba; 
}
.status-draft .status-dot { 
  background-color: #ffc107; 
}

/* MERAH - Gagal/Ditolak */
.status-rejected { 
  background-color: #f8d7da !important; 
  color: #721c24 !important; 
  border: 1px solid #f5c6cb; 
}
.status-rejected .status-dot { 
  background-color: #dc3545; 
}

/* UNGU - Kehamilan */
.status-pregnant { 
  background-color: #e2d9f3 !important; 
  color: #5a3294 !important; 
  border: 1px solid #d1c4e9; 
}
.status-pregnant .status-dot { 
  background-color: #9b59b6; 
  animation: pulse-purple 2s infinite; 
}

/* KELABU - Tiada ART / Tidak Aktif */
.status-none { 
  background-color: #e2e3e5 !important; 
  color: #383d41 !important; 
  border: 1px solid #d6d8db; 
}
.status-none .status-dot { 
  background-color: #adb5bd; 
}


@keyframes pulse-green {
  0%   { box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.4); }
  70%  { box-shadow: 0 0 0 6px rgba(40, 167, 69, 0); }
  100% { box-shadow: 0 0 0 0 rgba(40, 167, 69, 0); }
}

@keyframes pulse-blue {
  0%   { box-shadow: 0 0 0 0 rgba(23, 162, 184, 0.4); }
  70%  { box-shadow: 0 0 0 6px rgba(23, 162, 184, 0); }
  100% { box-shadow: 0 0 0 0 rgba(23, 162, 184, 0); }
}

@keyframes pulse-purple {
  0%   { box-shadow: 0 0 0 0 rgba(155, 89, 182, 0.4); }
  70%  { box-shadow: 0 0 0 6px rgba(155, 89, 182, 0); }
  100% { box-shadow: 0 0 0 0 rgba(155, 89, 182, 0); }
}

/* Page Container */
.page-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 15px;
}

/* Card Styles */
.modern-card {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  background: #fff;
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #f0f0f0;
}

.card-title {
  font-size: 22px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.close-btn {
  background-color: #f8f9fa;
  color: #6c757d;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 8px 16px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.close-btn:hover {
  background-color: #e9ecef;
  color: #495057;
}

.card-content {
  padding: 24px;
}

/* Main Layout */
.ternakan-container {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 30px;
  margin-bottom: 30px;
}

/* Image Section */
.image-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.slide-box {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  width: 100%;
}

/* Fix untuk vueper-slides agar gambar tidak terpotong */
:deep(.vueperslides) {
  height: auto !important;
}

:deep(.vueperslides__inner) {
  height: auto !important;
}

:deep(.vueperslides__parallax-wrapper) {
  padding-bottom: 75% !important; /* Rasio 4:3 */
  height: auto !important;
}

:deep(.vueperslides__track) {
  position: absolute !important;
  top: 0 !important;
  height: 100% !important;
}

:deep(.vueperslide) {
  background-size: contain !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
}

:deep(.vueperslide__image) {
  object-fit: contain !important;
  width: 100% !important;
  height: 100% !important;
}

/* Upload Section */
.upload-section {
  display: flex;
  justify-content: center;
}

.upload-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: #4a69bd;
  color: white;
  padding: 12px 20px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
}

.upload-btn:hover {
  background-color: #3c5aa6;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(74, 105, 189, 0.3);
}

.upload-icon {
  font-size: 18px;
}

.upload-input-hidden {
  display: none;
}

/* Attachment List */
.attachment-list {
  margin-top: 10px;
}

.attachment-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #2c3e50;
}

.attachment-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f8f9fa;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 10px;
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
}

.attachment-item:hover {
  background: #e9ecef;
  transform: translateX(3px);
}

.file-info {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
}

.file-icon {
  color: #4a69bd;
  font-size: 18px;
}

.file-link {
  color: #4a69bd;
  font-weight: 500;
  text-decoration: none;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

.file-link:hover {
  text-decoration: underline;
}

.delete-btn {
  min-width: 32px;
  padding: 4px;
}

/* Info Section */
.info-section {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 20px;
  height: 100%;
}

.info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e9ecef;
}

.info-title {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.livestock-id {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  padding: 8px 12px;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.id-label {
  font-weight: 500;
  color: #6c757d;
  font-size: 14px;
}

.id-value {
  font-weight: 600;
  color: #2c3e50;
  font-size: 14px;
}

.info-columns {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.info-group {
  background: #fff;
  border-radius: 10px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.info-item {
  margin-bottom: 14px;
}

.info-item:last-child {
  margin-bottom: 0;
}

.info-label {
  font-size: 13px;
  color: #6c757d;
  margin-bottom: 4px;
  font-weight: 500;
}

.info-value {
  font-size: 15px;
  color: #2c3e50;
  font-weight: 500;
}

/* Tabs Section */
.tabs-section {
  margin-top: 10px;
}

.modern-tabs {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.tab-content {
  padding: 24px;
  background: #fff;
  min-height: 200px;
}

/* Override default w-tabs styles */
:deep(.w-tabs__bar) {
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

:deep(.w-tabs__item) {
  padding: 14px 20px;
  font-weight: 500;
  transition: all 0.3s ease;
  color: #6c757d;
}

:deep(.w-tabs__item:hover) {
  background-color: rgba(74, 105, 189, 0.1);
  color: #4a69bd;
}

:deep(.w-tabs__item--active) {
  color: #4a69bd;
  border-bottom: 3px solid #4a69bd;
}

:deep(.w-tabs__slider) {
  background-color: #4a69bd;
  height: 3px;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .info-columns {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 992px) {
  .ternakan-container {
    grid-template-columns: 1fr;
  }
  
  .info-columns {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 576px) {
  .card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .info-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .attachment-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .file-link {
    max-width: 100%;
  }
  
  :deep(.w-tabs__item) {
    padding: 12px 15px;
    font-size: 14px;
  }
  
  :deep(.vueperslides__parallax-wrapper) {
    padding-bottom: 100% !important; 
  }
}
</style>